/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { ReceiptLinesService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { ReceiptLineStore } from './receipt-line.store';
import {
    ReceiptLineCreate,
    ReceiptLineRead,
    ReceiptLineSearchParams,
} from '../../entities/receipt-line.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class ReceiptLineDataService extends AbstractDataService<
    ReceiptLineRead,
    ReceiptLineCreate
> {
    protected EntityName = PFWmsEntities.ReceiptLine;
    constructor(
        private service: ReceiptLinesService,
        store: ReceiptLineStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(
        body: ReceiptLineCreate,
        receiptId?: string
    ): Observable<ReceiptLineRead> {
        return this.service.receiptLineCreate({
            receiptId: receiptId as string,
            receiptLineViewModelCreateBody: body,
        }) as Observable<ReceiptLineRead>;
    }
    protected deleteObs$(
        id: string,
        receiptId?: string
    ): Observable<ReceiptLineRead> {
        return this.service.receiptLineDelete({
            id,
            receiptId: receiptId as string,
        }) as Observable<ReceiptLineRead>;
    }
    protected undoDeleteObs$(
        id: string,
        receiptId?: string
    ): Observable<ReceiptLineRead> {
        return this.service.receiptLineUndoDelete({
            id,
            receiptId: receiptId as string,
        }) as Observable<ReceiptLineRead>;
    }
    protected getObs$(
        id: string,
        receiptId?: string
    ): Observable<ReceiptLineRead> {
        return this.service.receiptLineReadById({
            id,
            receiptId: receiptId as string,
        }) as Observable<ReceiptLineRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[],
        _: ReceiptLineCreate,
        receiptId?: string
    ): Observable<ReceiptLineRead> {
        return this.service.receiptLineUpdatePatch({
            id,
            receiptId: receiptId as string,
            operation: operations,
        }) as Observable<ReceiptLineRead>;
    }
    protected searchObs$(
        searchParams: ReceiptLineSearchParams
    ): Observable<IPagedResult<ReceiptLineRead>> {
        return this.service.receiptLineSearch(searchParams) as Observable<
            IPagedResult<ReceiptLineRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<ReceiptLineRead>>> {
        const { parentId, ...params } = searchParams;
        return this.service.receiptLineGetChanges({
            ...params,
            receiptId: parentId as string,
        }) as Observable<
            IPagedResult<EntityChangeTrackingDto<ReceiptLineRead>>
        >;
    }

    public getByReceiptLineId$(id: string): Observable<ReceiptLineRead> {
        return this.service.receiptLineGetById({
            receiptLineId: id,
        }) as Observable<ReceiptLineRead>;
    }
}
